import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as LotActionType from "../constants";
import { Tab, Row, Col, Nav, NavItem } from "react-bootstrap";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import folder from "assets/img/folder.png";
import emptyImages from "assets/img/file_image.png";
import word from "assets/img/file_word.png";
import excel from "assets/img/file_excel.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import other from "assets/img/file_other.png";
import { Modal } from "react-bootstrap";
import { InventoryCategoryModal } from "../Components/inventoryCategoryAddEditModal";
import { InventoryAddItemModal } from "../Components/inventoryAddItem";
import "../inventory.scss";
import { InventoryEditItemModal } from "../Components/inventoryEditItem";
import InventoryItemView from "../Components/inventoryItemView";

class HomeOwnerInventory extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    HomeownerLots: PropTypes.array,
    homeownerLotSelectList: PropTypes.array,
    projectId: PropTypes.any,
    HomeownerInventoryCategoryItems: PropTypes.array,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      documents: [],
      selectedCategory: "",
      editCategorySelected: "",
      searchQuery: "",
      isEdit: false,
      sortAscending: false,
      categoryItems: null,
      lotSortAscending: false,
      showModal: false,
      lot: null,
      itemEdit: null,
      inventoryCategory: [],
      showModalItemLinked: false,
      itemDetailsForEdit: null,
      viewItem: null,
      defaultLot: null,
    };
  }
  componentDidMount() {
    this.fetchLot();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevLot = prevState.lot;
    const currentLot = this.state.lot;

    if (
      (!prevLot && currentLot) ||
      (prevLot && currentLot && prevLot.value !== currentLot.value)
    ) {
      this.fetchInventoryCategories();
    }

    // Handle lot selection when lots become available AND default lot is fetched
    if (
      this.props.homeownerLotSelectList.length > 0 &&
      !this.state.lot &&
      this.state.defaultLot !== null &&
      (prevProps.homeownerLotSelectList !== this.props.homeownerLotSelectList ||
        prevState.defaultLot !== this.state.defaultLot)
    ) {
      this.selectInitialLot();
    }
  }

  renderNoFiles = () => {
    return (
      <div className="lot-document-no-files">
        <img className="lot-document-no-files-ic" src={folder} alt="no-files" />
        <p className="lot-document-no-files-text">No Items found.</p>
        <p className="lot-document-no-files-text">
          Tap on 'Add Item' to add here
        </p>
      </div>
    );
  };

  fetchLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC,
    });
    this.props.dispatch({
      type: LotActionType.GET_DEFAULT_LOT,
      callback: (response) => {
        if (response && response.data && response.data.lotId) {
          this.setState({ defaultLot: response.data.lotId });
        } else {
          this.setState({ defaultLot: false });
        }
      },
    });
  };

  selectInitialLot = () => {
    const { homeownerLotSelectList } = this.props;
    const { defaultLot } = this.state;
    let lotToSelect = null;

    if (this.lotId) {
      lotToSelect = homeownerLotSelectList.find((l) => l.value === this.lotId);
      if (lotToSelect) {
        this.setState({ lot: lotToSelect });
        this.removeQueryParam && this.removeQueryParam("lotId");
        return;
      }
    }

    // Try to find default lot first
    if (defaultLot && defaultLot !== false) {
      lotToSelect = homeownerLotSelectList.find(
        (lot) => lot.value === defaultLot
      );
    }

    // If no default lot found, use first lot
    if (!lotToSelect && homeownerLotSelectList.length > 0) {
      lotToSelect = homeownerLotSelectList[0];
    }

    if (lotToSelect) {
      this.setState({ lot: lotToSelect });
    }
  };

  isImageUrl = (url) => {
    if (!url) return false;
    const imageExts = ["jpg", "jpeg", "png", "gif", "heic", "heif", "bmp", "webp"];
    const ext = url.split(".").pop().split("?")[0].toLowerCase();
    return imageExts.includes(ext);
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif", "heic", "heif"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];

    const fileName = item.fileName || item.name;
    if (!fileName) return other;

    const ext = fileName.split(".").pop().toLowerCase();

    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage.includes(ext)) {
      return item.imageUrl || item.thumbnailUrl || URL.createObjectURL(item);
    } else {
      return other;
    }
  };

  onSelectLot = (event) => {
    this.setState({
      lot: event.value,
    });
  };

  // MODIFIED: Consolidated fetchInventoryCategories and fetchInventoryCategoriesHo
  // This is now the single source of truth for fetching categories.
  fetchInventoryCategories = (isRefetch = false) => {
    const { lot } = this.state;

    // Guard clause: Do not fetch if lot is not ready.
    if (!lot || !lot.extensionValue || !lot.extensionValue.builderProfile) {
      // console.warn("Cannot fetch inventory categories: lot or builderProfile is missing or incomplete.");
      return;
    }

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_INVENTORY_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: lot.value,
      },
      callback: (data) => {
        const newCategories = data.data || [];
        let newSelectedCategory = "";

        if (newCategories.length > 0) {
          // If this is a refetch (e.g., after adding/deleting), try to keep the same category selected.
          const currentCategoryStillExists =
            isRefetch &&
            newCategories.some((c) => c.id === this.state.selectedCategory);

          if (currentCategoryStillExists) {
            newSelectedCategory = this.state.selectedCategory;
          } else {
            // Otherwise, default to the first category in the new list.
            newSelectedCategory = newCategories[0].id;
          }
        }

        this.setState(
          {
            inventoryCategory: newCategories,
            selectedCategory: newSelectedCategory,
          },
          () => {
            // After setting the state, fetch the items for the selected category.
            if (this.state.selectedCategory) {
              this.getItemsByCategory();
            } else {
              // If there are no categories, ensure items are cleared.
              this.setState({ categoryItems: null });
            }
          }
        );
      },
    });
  };

  getItemsByCategory = () => {
    const { lot, selectedCategory } = this.state;

    // Guard clause: Do not proceed if essential data is missing.
    if (
      !lot ||
      !selectedCategory ||
      !lot.extensionValue ||
      !lot.extensionValue.builderProfile
    ) {
      // console.warn("Cannot get items by category: lot, selectedCategory, or builderProfile is missing or incomplete.");
      return;
    }

    const { builderProfile } = lot.extensionValue;

    const params = {
      CategoryId: selectedCategory,
      LotId: lot.value,
    };

    this.props.dispatch({
      type: LotActionType.GET_ITEM_BY_INVENTORY_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: params,
      },
      callback: (data) => {
        this.setState({ categoryItems: data });
      },
    });
  };

  onSelectCategory = (key) => {
    this.setState({ selectedCategory: key }, () => {
      this.getItemsByCategory();
    });
  };

  handleFileDrop = (files) => {
    this.setState({ uploadedFiles: files });
  };

  handleOpenModal = () => {
    this.setState({ showModal: true, isEdit: false });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, isEdit: false });
  };

  handleOpenAddItemModal = () => {
    this.setState({ showAddItemModal: true });
  };

  handleCloseAddItemModal = () => {
    this.setState({ showAddItemModal: false }, () => {
      // Refresh data after modal closes to ensure UI is updated
      if (this.state.selectedCategory) {
        this.getItemsByCategory();
      }
    });
  };

  handleOpenItemDeleteModal = (id) => {
    this.setState({ showModalItemDelete: true, deleteItemId: id });
  };

  handleOpenViewItemModal = (item) => {
    this.setState({ showViewItemModal: true, viewItem: item });
  };

  handleCloseViewItemModal = () => {
    this.setState({ showViewItemModal: false });
  };

  handleCloseEditItemModal = () => {
    this.setState({ showItemEditModal: false });
  };

  handleEditOpenModal = (type) => {
    this.setState({
      showModal: true,
      isEdit: true,
      editCategorySelected: type,
    });
  };

  handleItemEditOpenModal = (itemid) => {
    this.setState({
      showItemEditModal: true,
    });
    this.getInventoryDetails(itemid);
  };

  getInventoryDetails = (itemid) => {
    const { lot } = this.state;

    if (!lot || !lot.extensionValue || !lot.extensionValue.builderProfile) {
      console.error(
        "Cannot get inventory details: lot or builderProfile is missing"
      );
      return;
    }

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_SPECIFIC_INVENTORY_ID,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: {
          itemid,
          lotid: lot.value,
        },
      },
      callback: (data) => {
        this.setState({ itemDetailsForEdit: data.data });
      },
    });
  };

  sortDocumentsByName = () => {
    const { sortAscending, documents } = this.state;
    if (!documents) return;

    const sortedDocuments = [...documents].sort((a, b) => {
      const nameA = a.fileName.toLowerCase();
      const nameB = b.fileName.toLowerCase();
      if (nameA < nameB) return sortAscending ? -1 : 1;
      if (nameA > nameB) return sortAscending ? 1 : -1;
      return 0;
    });

    this.setState({
      documents: sortedDocuments,
      sortAscending: !sortAscending,
    });
  };

  deleteCategory = () => {
    const { lot, deleteSelectedCategory } = this.state;

    if (!lot || !lot.extensionValue || !lot.extensionValue.builderProfile) {
      console.error("Cannot delete category: lot or builderProfile is missing");
      return;
    }

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.DELETE_INVENTORY_CATEGORY_ASYNC,
      params: {
        url: builderProfile.builderHost,
        categoryId: deleteSelectedCategory.id,
        lotId: lot.value,
      },
      callback: () => {
        // Pass 'true' to indicate it's a refetch
        this.fetchInventoryCategories(true);
      },
    });
  };

  deleteItem = () => {
    const { lot, deleteItemId } = this.state;

    if (!lot || !lot.extensionValue || !lot.extensionValue.builderProfile) {
      console.error("Cannot delete item: lot or builderProfile is missing");
      return;
    }

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.DELETE_INVENTORY_ITEM_HO_ASYNC,
      params: {
        url: builderProfile.builderHost,
        itemId: deleteItemId,
      },
      callback: () => {
        this.setState(
          {
            showModalItemDelete: false,
          },
          () => {
            // Pass 'true' to indicate it's a refetch
            this.fetchInventoryCategories(true);
          }
        );
      },
    });
  };

  ValidatedeleteCategory = (item) => {
    if (item.itemCount > 0) {
      this.setState({
        showModalItemLinked: true,
        message:
          "You can't delete this category because there are inventories associated with it. Please reassign or remove them first.",
        deleteCat: false,
      });
    } else {
      this.setState({
        showModalItemLinked: true,
        message: "Are you sure you want to delete this category?",
        deleteCat: true,
        deleteSelectedCategory: item,
      });
    }
  };

  sortCategoryByName = () => {
    const { lotSortAscending, inventoryCategory } = this.state;
    if (!inventoryCategory || !inventoryCategory.data) return;

    const sortedCategoryData = [...inventoryCategory.data].sort((a, b) => {
      const nameA = a.text.toLowerCase();
      const nameB = b.text.toLowerCase();
      if (nameA < nameB) return lotSortAscending ? -1 : 1;
      if (nameA > nameB) return lotSortAscending ? 1 : -1;
      return 0;
    });

    this.setState({
      inventoryCategory: {
        ...inventoryCategory,
        data: sortedCategoryData,
      },
      lotSortAscending: !lotSortAscending,
    });
  };

  render() {
    const {
      lot,
      itemEdit,
      inventoryCategory,
      documents,
      selectedCategory,
      editCategorySelected,
      categoryItems,
      searchQuery,
      sortAscending,
    } = this.state;
    const { homeownerLotSelectList, HomeownerInventoryCategoryItems } =
      this.props;
    const isDisabled = !Array.isArray(documents) || documents.length === 0;
    const isDisabledSorting =
      !categoryItems ||
      !Array.isArray(categoryItems.data) ||
      categoryItems.data.length === 0;

    let filteredItems =
      categoryItems && categoryItems.data ? [...categoryItems.data] : [];

    // Apply search
    if (searchQuery.trim() !== "") {
      filteredItems = filteredItems.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
      );
    }

    // Apply sorting
    filteredItems.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) return sortAscending ? -1 : 1;
      if (nameA > nameB) return sortAscending ? 1 : -1;
      return 0;
    });

    return (
      <div className="container-fluid app-container">
        <div
          className="project-document-wrapper homeowner-document"
          style={{ padding: 15 }}
        >
          <Tab.Container
            id="left-tabs-example"
            className="document-tab"
            activeKey={selectedCategory}
            // MODIFIED: Use the onSelect handler from the Tab container
            // This is the correct React-Bootstrap way to handle tab changes
            onSelect={this.onSelectCategory}
          >
            <Row className="clearfix">
              <div>
                <Col sm={3} className="doc-category">
                  <div>
                    <label className="control-label">Property</label>
                    <div className="control-label">
                      <div className="select-lot">
                        <Dropdown
                          onChange={this.onSelectLot} // This handler was modified
                          filter={true}
                          className="filestring-dropdown filter-dropdown"
                          options={homeownerLotSelectList}
                          optionLabel="text"
                          onRemote={this.fetchLot}
                          value={lot}
                          name="lot"
                          placeholder="-- Please select"
                          style={{
                            width: "21vw",
                            display: "inline-block",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {lot && inventoryCategory.length > 0 ? (
                    <Nav bsStyle="pills" stacked>
                      {inventoryCategory.map((type) => {
                        return (
                          <NavItem
                            eventKey={type.id}
                            key={type.id}
                            className={
                              itemEdit && itemEdit.value === type.id
                                ? "document-nav-tab document-nav-tab-edit"
                                : "document-card"
                            }
                          >
                            <div className="document-card-content">
                              <div className="left-section">
                                <img
                                  src={this.renderFileTypeIcon(type)}
                                  className="doc-icon-category"
                                  alt={type.name}
                                />
                              </div>

                              <div className="middle-section">
                                <div className="doc-title">{type.name}</div>
                                <div className="doc-subtitle">
                                  {type.itemCount} Items
                                </div>
                              </div>

                              <div className="right-section">
                                {/*  */}
                                <div className="btn-group">
                                  <button
                                    className="btn btn-default btn-sm dropdown-toggle"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <i
                                      className="fa fa-ellipsis-v menu-icon"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <ul className="dropdown-menu">
                                    <li>
                                      <a
                                        id={type.id}
                                        onClick={() =>
                                          this.handleEditOpenModal(type)
                                        }
                                      >
                                        <span
                                          className="fa fa-pencil "
                                          style={{
                                            color: "#4a4a4a",
                                            marginRight: 6,
                                          }}
                                        />
                                        Edit category
                                      </a>
                                    </li>
                                    {type.isBuilderUploaded == false ? (
                                      <li>
                                        <a
                                          id={type.id}
                                          onClick={() =>
                                            this.ValidatedeleteCategory(type)
                                          }
                                          style={{
                                            color: "red",
                                          }}
                                        >
                                          <span
                                            className="fa fa-trash"
                                            style={{
                                              marginRight: 6,
                                            }}
                                          />
                                          Delete category
                                        </a>
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </NavItem>
                        );
                      })}
                    </Nav>
                  ) : (
                    <p style={{ textAlign: "center" }}>
                      No category found.
                      <br /> <br />
                      Tap on 'Add Category' to add here
                    </p>
                  )}
                  <button
                    type="button"
                    className="add-category-btn"
                    onClick={this.handleOpenModal}
                  >
                    + Add Category
                  </button>
                </Col>
                <Col sm={9} className="doc-listing-section">
                  <div className="heading-div">
                    <div className="name-sort-btn">
                      <button
                        className="name-btn"
                        type="button"
                        data-toggle="dropdown"
                        disabled={isDisabledSorting}
                        onClick={() =>
                          this.setState((prevState) => ({
                            sortAscending: !prevState.sortAscending,
                          }))
                        }
                        style={
                          isDisabledSorting
                            ? { opacity: 0.5, cursor: "not-allowed" }
                            : {}
                        }
                      >
                        Name
                        {this.state.sortAscending ? (
                          <i className="fa fa-angle-up" aria-hidden="true"></i>
                        ) : (
                          <i
                            className="fa fa-angle-down"
                            aria-hidden="true"
                          ></i>
                        )}
                      </button>
                    </div>

                    <div
                      className="search-container"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <i
                        className="fa fa-search"
                        style={{
                          position: "relative",
                          left: "30px",
                          pointerEvents: "none",
                          color: "rgb(159 155 155)",
                          fontSize: "16px",
                        }}
                        aria-hidden="true"
                      ></i>
                      <input
                        type="text"
                        placeholder="Search an item"
                        className="search-input"
                        style={{
                          padding: "7px 14px 6px 35px",
                          borderRadius: "50px",
                          border: "1px solid #ccc",
                          width: "250px",
                        }}
                        value={this.state.searchQuery}
                        onChange={(e) =>
                          this.setState({ searchQuery: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <Tab.Content
                    animation
                    style={{
                      paddingLeft: 15,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Tab.Pane eventKey={selectedCategory}>
                      {lot && filteredItems.length > 0 ? (
                        <div className="item-grid">
                          {filteredItems.map((item, index) => (
                            <div className="item-detail-card" key={index}>
                              <div
                                onClick={() =>
                                  this.handleOpenViewItemModal(item)
                                }
                                style={{ cursor: "pointer" }}
                                title={`View item ${item.name}`}
                              >
                                <div className="image-wrapper">
                                  <div className="image-block">
                                    <img
                                      src={
                                        item.images && item.images[0] && this.isImageUrl(item.images[0].thumbnailUrl)
                                          ? item.images[0].thumbnailUrl
                                          : emptyImages
                                      }
                                      alt={item.name}
                                      className="doc-img-upload"
                                    />
                                  </div>
                                </div>
                                <div className="item-name">
                                  {item.name.length > 30
                                    ? `${item.name.slice(0, 30)}...`
                                    : item.name}
                                </div>
                                <div
                                  className={`warranty-status ${
                                    item.warrantyText === "Out of Warranty"
                                      ? "out-of-warranty"
                                      : "in-warranty"
                                  }`}
                                >
                                  {item.warrantyText}
                                </div>
                              </div>
                              <div className="item-menu">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-default btn-sm dropdown-toggle"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    style={{ border: "none" }}
                                    title="Open dropdown"
                                  >
                                    <i
                                      className="fa fa-ellipsis-v menu-icon"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <ul className="dropdown-menu">
                                    <li title={`Edit item ${item.name}`}>
                                      <a
                                        onClick={() =>
                                          this.handleItemEditOpenModal(item.id)
                                        }
                                      >
                                        <span className="fa fa-pencil" />
                                        Edit
                                      </a>
                                    </li>
                                    <li title={`View item ${item.name}`}>
                                      <a
                                        onClick={() =>
                                          this.handleOpenViewItemModal(item)
                                        }
                                      >
                                        <span className="fa fa-eye" />
                                        View
                                      </a>
                                    </li>
                                    {item.isBuilderUploaded === false && (
                                      <li title={`Delete item ${item.name}`}>
                                        <a
                                          onClick={() =>
                                            this.handleOpenItemDeleteModal(
                                              item.id
                                            )
                                          }
                                          className="delete-option"
                                        >
                                          <span className="fa fa-trash" />
                                          Delete
                                        </a>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        this.renderNoFiles()
                      )}
                    </Tab.Pane>
                  </Tab.Content>
                  <button
                    type="button"
                    className="add-document-btn"
                    onClick={this.handleOpenAddItemModal}
                  >
                    + Add item
                  </button>
                </Col>
              </div>
            </Row>
          </Tab.Container>
        </div>
        {this.state.showModalItemLinked && (
          <Modal
            dialogClassName="confirm-cancel-save-eoc-template-dialog"
            show={this.state.showModalItemLinked}
            centered="true"
            size="sm"
          >
            <Modal.Header>
              <Modal.Title>
                <h3> {this.state.deleteCat ? "Confirm Delete" : "Alert !"}</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{this.state.message}</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="suspend-group-btn" style={{ float: "left" }}>
                {this.state.deleteCat ? (
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      this.deleteCategory();

                      this.setState({
                        showModalItemLinked: false,
                        deleteSelectedCategory: null,
                      });
                    }}
                  >
                    Yes, Delete
                  </button>
                ) : (
                  ""
                )}
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    this.setState({
                      showModalItemLinked: false,
                      deleteSelectedCategory: null,
                    })
                  }
                >
                  {this.state.deleteCat ? "Cancel" : "Close"}
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}

        {this.state.showModalItemDelete && (
          <Modal
            dialogClassName="confirm-cancel-save-eoc-template-dialog"
            show={this.state.showModalItemDelete}
            centered="true"
            size="sm"
          >
            <Modal.Header>
              <Modal.Title>
                <h3> Confirm Delete</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this inventory item</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="suspend-group-btn" style={{ float: "left" }}>
                <button className="btn btn-danger" onClick={this.deleteItem}>
                  Yes, Delete
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    this.setState({
                      showModalItemDelete: false,
                    })
                  }
                >
                  Cancel{" "}
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}

        {lot && (
          <React.Fragment>
            <InventoryEditItemModal
              isOpen={this.state.showItemEditModal}
              closeModal={this.handleCloseEditItemModal}
              accept=".pdf,.docx,.png,.jpg"
              lot={lot}
              onDrop={this.handleFileDrop}
              selectedCategory={selectedCategory}
              dispatch={this.props.dispatch}
              getItemsByCategory={this.getItemsByCategory}
              fetchInventoryCategories={() =>
                this.fetchInventoryCategories(true)
              }
              itemDetails={this.state.itemDetailsForEdit}
              isEdit={true}
              getInventoryDetails={this.getInventoryDetails}
            />

            <InventoryAddItemModal
              isOpen={this.state.showAddItemModal}
              closeModal={this.handleCloseAddItemModal}
              accept=".pdf,.docx,.png,.jpg,.jpeg"
              lot={lot}
              onDrop={this.handleFileDrop}
              selectedCategory={this.state.selectedCategory}
              inventoryCategory={inventoryCategory}
              dispatch={this.props.dispatch}
              fetchInventoryCategoriesHo={() => {
                this.fetchInventoryCategories(true);
                // Also refresh current category items
                setTimeout(() => {
                  if (this.state.selectedCategory) {
                    this.getItemsByCategory();
                  }
                }, 500);
              }}
            />

            <InventoryItemView
              isOpen={this.state.showViewItemModal}
              isOpenEdit={this.handleItemEditOpenModal}
              closeModal={this.handleCloseViewItemModal}
              selectedCategory={this.state.selectedCategory}
              selectedItemtoView={this.state.viewItem}
              lot={lot}
              onDrop={this.handleFileDrop}
              dispatch={this.props.dispatch}
            />

            <InventoryCategoryModal
              isOpen={this.state.showModal}
              closeModal={this.handleCloseModal}
              isEdit={this.state.isEdit}
              accept=".pdf,.docx,.png,.jpg"
              lot={lot}
              onDrop={this.handleFileDrop}
              selectedCategory={editCategorySelected}
              dispatch={this.props.dispatch}
              getItemsByCategory={this.getItemsByCategory}
              fetchInventoryCategories={() =>
                this.fetchInventoryCategories(true)
              }
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    HomeownerLots: state.LotStore.HomeownerLots,
    homeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
    inventoryCategory: state.LotStore.inventoryCategory,
    HomeownerInventoryCategoryItems:
      state.LotStore.HomeownerInventoryCategoryItems,
  };
};

export default connect(mapStateToProps)(HomeOwnerInventory);



// WEBPACK FOOTER //
// ./src/Lots/Containers/homeowner-inventory.js